import { Dehaze } from '@mui/icons-material';
import { RoutalSearchInput } from './RoutalSearchInput';
import { RoutalSelect, RoutalSelectMultiSelectOptions } from './RoutalSelect';

type SearchInputProps = {
  id: string;
  searchText: string;
  options: RoutalSelectMultiSelectOptions;
  onTextChange: (...args: any[]) => any;
};

export const RoutalSearchInputSelector = ({ searchText, options, id, onTextChange }: SearchInputProps) => {
  return (
    <>
      <RoutalSearchInput
        fieldValue={searchText}
        inputContainerStyles={{
          height: `38px`,
          borderRadius: `5px 0 0 5px`,
        }}
        onChange={onTextChange}
      />
      <RoutalSelect
        id={`search-selector-button-${id}`}
        style={{
          backgroundColor: `#E9E9E9`,
          color: `#707070`,
          padding: `4px 2px`,
          marginLeft: `-1px`,
          margin: 0,
          height: `38px`,
          borderRadius: `0 5px 5px 0`,
          border: `1px solid #D4D1D1`,
          borderLeft: 0,
        }}
        containerStyle={{
          width: `54px`,
        }}
        hideSeparator
        popoverProps={{
          maxHeight: `500px`,
          options,
        }}
        arrowStyle={{
          color: `#707070`,
        }}
      >
        <Dehaze />
      </RoutalSelect>
    </>
  );
};
